export default {
  COMPNAME: "avue-echart-",
  NAME: "list",
  DEAFNAME: 'item'
}
export const url = 'https://data.bladex.vip/blade-visual'